import { keymap } from "prosemirror-keymap";
import { Extension } from "../../core/extension";
import { changeParentNode } from "../../commands/commands";
import { headingNodes } from "./nodes";
import { HeadingNodeView } from "./nodeviews";
import { HeadingCollapsePlugin } from "./plugins/heading-collapse-plugin";
import { HeadingIdPlugin } from "./plugins/heading-id-plugin";
import { changeNodeIndentation, HeadingIndentationPlugin, } from "./plugins/heading-indentation-plugin";
import { handleEnterOnHeading, insertParagraphAfterHeading, } from "./plugins/heading-add-paragraph";
export const defaultOptions = {
    collapse: true,
    indent: true,
};
export class HeadingExtension extends Extension {
    constructor(options = defaultOptions) {
        super();
        this.options = options;
    }
    addNodes(nodes) {
        return nodes.append(headingNodes);
    }
    addNodeViews(schema, nodeViews) {
        if (!this.options.collapse) {
            return nodeViews;
        }
        return {
            ...nodeViews,
            heading: (node, view, getPos) => new HeadingNodeView(node, view, getPos),
        };
    }
    addPlugins(schema, plugins) {
        let updatedPlugins = plugins.concat([HeadingIdPlugin()]);
        if (this.options.collapse) {
            updatedPlugins = updatedPlugins.concat([
                HeadingCollapsePlugin(),
                keymap({
                    Enter: handleEnterOnHeading(schema),
                    "Shift-Enter": insertParagraphAfterHeading(schema),
                }),
            ]);
        }
        if (this.options.indent) {
            updatedPlugins = updatedPlugins.concat([
                HeadingIndentationPlugin(),
                keymap({
                    Tab: changeNodeIndentation(schema.nodes.heading, 1),
                    "Shift-Tab": changeNodeIndentation(schema.nodes.heading, -1),
                }),
            ]);
        }
        return updatedPlugins;
    }
    addCommands(schema) {
        return {
            applyHeading: (level) => changeParentNode(schema.nodes.heading, { level }),
        };
    }
}
